import { NgModule } from '@angular/core';
import { FiSwipeRightDirective } from './fi-swipe-right.directive';
import { FiSwipeLeftDirective } from './fi-swipe-left.directive';
import { FiSwipeDownDirective } from '@fi-shared/fi-directives/fi-swipe/fi-swipe-down.directive';

@NgModule({
    declarations: [FiSwipeRightDirective, FiSwipeLeftDirective, FiSwipeDownDirective],
    exports: [FiSwipeRightDirective, FiSwipeLeftDirective, FiSwipeDownDirective],
})
export class FiSwipeModule {}
